import React from 'react'

import moment from 'moment'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import { Tooltip } from 'antd';
import { connect } from 'react-redux';
import { requestServerPost, requestServerGet, selectPage } from '../../actions';

const inputdateFormat = 'YYYY-MM-DD';
class CalendarView extends React.Component {

    constructor(props) {
        super(props);
        this.state = { schedulerData: [], timelineDatas: [] }
    }
    componentDidMount() {
        const { datas } = this.props
        this.prepareSchedulerData(datas);
    }

    componentDidUpdate(prevProp) {
        if ("datas" in this.props && this.props.datas !== prevProp.datas) {
            const { datas } = this.props
            this.prepareSchedulerData(datas);
        }
    }

    prepareSchedulerData = (timelineDatas) => {
        // Build one calendar event per schedule entry (not just [0])
        const events = [];

        timelineDatas.forEach((tl, index) => {
            if (!tl.Timelineschedules || tl.Timelineschedules.length === 0) return;

            tl.Timelineschedules.forEach((schedule, schedIdx) => {
                var startDate = moment().subtract(1, 'years').format(inputdateFormat);
                var endDate   = moment().add(1, 'years').format(inputdateFormat);
                var title = tl.TimelineName;

                if (schedule.StartDate && schedule.StartDate !== '') {
                    startDate = schedule.StartDate;
                }
                if (schedule.EndDate && schedule.EndDate !== '') {
                    const m = moment(schedule.EndDate, inputdateFormat);
                    endDate = m.add(1, 'days').format(inputdateFormat);
                }

                var startTime = '';
                var endTime   = '';

                if (schedule.StartTime && schedule.StartTime !== '') {
                    startTime = schedule.StartTime;
                    startDate = `${startDate}T${schedule.StartTime}`;
                }
                if (schedule.EndTime && schedule.EndTime !== '') {
                    endTime = schedule.EndTime;
                    // use original EndDate (without +1 day) for timed events
                    const baseEnd = schedule.EndDate && schedule.EndDate !== '' ? schedule.EndDate : moment().add(1, 'years').format(inputdateFormat);
                    endDate = `${baseEnd}T${schedule.EndTime}`;
                }

                if (startTime !== '' || endTime !== '') {
                    const st = (startTime || '00:00:00').split(':').slice(0, 2).join(':');
                    const et = (endTime   || '23:59:00').split(':').slice(0, 2).join(':');
                    title = `${tl.TimelineName} [${st}–${et}]`;
                }

                var weekdays = schedule.WeekDay
                    ? schedule.WeekDay.split(',').map(d => parseInt(d)).filter(n => !isNaN(n))
                    : [];

                events.push({
                    order:              index,
                    timelineid:         tl.TimelineID,
                    timelineScheduleid: schedule.TimelineScheduleID,
                    title,
                    start:              startDate,
                    end:                endDate,
                    daysOfWeek:         weekdays,
                    startRecur:         startDate,
                    endRecur:           endDate,
                    editable:           false,
                    color:              tl.color,
                    extendedProps: {
                        timelineName: tl.TimelineName,
                        startTime,
                        endTime,
                        weekdays,
                    },
                });
            });
        });

        this.setState({ schedulerData: events, timelineDatas });
    }

    renderEventContent = (eventInfo) => {
        return (
            <Tooltip title={eventInfo.event.title} placement="top" trigger={['hover', 'click']}>
                <div className="cdx-cal-event-pill" style={{ backgroundColor: eventInfo.event.backgroundColor }}>
                    <span className="cdx-cal-event-dot" />
                    <span className="cdx-cal-event-title">{eventInfo.event.title}</span>
                </div>
            </Tooltip>
        );
    }

    render() {
        const { timelineDatas, schedulerData } = this.state;

        // Deduplicate legend entries by TimelineID
        const legend = [];
        const seen = new Set();
        timelineDatas.forEach(tl => {
            if (!seen.has(tl.TimelineID)) {
                seen.add(tl.TimelineID);
                legend.push({ id: tl.TimelineID, name: tl.TimelineName, color: tl.color });
            }
        });

        return (
            <div className="cdx-calendar-card">
                {/* Legend */}
                {legend.length > 0 && (
                    <div className="cdx-cal-legend">
                        {legend.map(item => (
                            <div key={item.id} className="cdx-cal-legend-item">
                                <span className="cdx-cal-legend-dot" style={{ backgroundColor: item.color }} />
                                <span className="cdx-cal-legend-label">{item.name}</span>
                            </div>
                        ))}
                    </div>
                )}

                {/* Calendar */}
                <div className="cdx-calendar-wrap">
                    <FullCalendar
                        eventOrder="order"
                        eventClick={() => {}}
                        plugins={[dayGridPlugin, interactionPlugin]}
                        initialView="dayGridMonth"
                        weekends={true}
                        editable={false}
                        events={schedulerData}
                        eventContent={this.renderEventContent}
                        displayEventTime={false}
                        headerToolbar={{
                            left:   'prev,next today',
                            center: 'title',
                            right:  'dayGridMonth,dayGridWeek',
                        }}
                        buttonText={{
                            today: 'Today',
                            month: 'Month',
                            week:  'Week',
                        }}
                        height="auto"
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return { userdata: state.userdata, usertoken: state.usertoken, selectedBrandData: state.selectedBrandData };
}

export default connect(mapStateToProps, { requestServerGet, requestServerPost, selectPage })(CalendarView);

